.header {
  position: sticky;
  top: 0;
  z-index: 2;

  > .visualHeader {
    font-family: var(--sans);
    background: #000;
    color: #fff;
    display: grid;
    grid-template-columns: auto 1fr;
    align-items: center;
    gap: 2px;
    box-shadow: var(--shadow-md);
    position: relative;

    > button,
    input,
    div > svg {
      animation: fadeIn 300ms;
    }

    h1 {
      font-size: 20px;
      margin: 0;
    }

    nav {
      position: absolute;
      top: 100%;
      left: 0;
      width: 100%;
      border-top: 1px solid #555;
      opacity: 0;
      pointer-events: none;
      transform: translateY(-200px);
      z-index: -1;
      transition:
        opacity 300ms,
        transform 300ms;
      box-shadow: var(--shadow-md);

      > ul {
        list-style: none;
        margin: 0;
        padding: 0;
      }
    }

    @media (min-width: 630px) {
      grid-template-columns: auto 1fr 400px 0fr;
      nav {
        max-width: 250px;
      }
    }

    nav.open {
      opacity: 1;
      pointer-events: auto;
      transform: none;
    }
  }
}

.clearDialog {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  max-width: 400px;

  header {
    h3 {
      margin: 0;
    }

    /* biome-ignore lint/style/noDescendingSpecificity: TODO: fix */
    button {
      display: none;
    }
  }

  > :not(button) {
    grid-column: span 2;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
}
